// import Vue from 'vue'
// import axios from 'axios'
// import VueAxios from 'vue-axios'
// Vue.use(axios)
// Vue.use(VueAxios)
import axios from '@/plugins/axios'

export default {
  install(Vue) {
    Vue.prototype.$pictureApiService = {
      picture_api_url: `${process.env.VUE_APP_DHARMA_API_URL}/pictures`,

      /**
       * 查詢
       * @param {string} param - API 查詢參數
       * @returns {Promise<Object>} API 回傳的資料結構
       */
      async query(param = '') {
        const url = `${this.picture_api_url}`
        const params = param ? `?${param}` : ''
        const response = await axios.get(`${url}${params}`)
        return response.data
      },
      
      /**
       * 透過關鍵字進行佛像的查詢
       * @param {string} keyword - 關鍵字
       * @param {string} additional - 額外的 API 查詢參數
       * @returns {Promise<Object>} API 回傳的資料結構
       */
      async queryByKeyword(keyword, additional = '') {
        const url = `${this.picture_api_url}?filter[of_keyword]=${keyword}`
        const additional_params = additional ? `&${additional}` : ''
        const response = await axios.get(`${url}${additional_params}`)
        return response.data
      },

      /**
       * 透過多個關鍵字進行佛像的查詢（AND 邏輯）
       * @param {string} keywords - 以逗號分隔的多個關鍵字（例如 '觀音,佛像'）
       * @param {string} additional - 額外的 API 查詢參數
       * @returns {Promise<Object>} API 回傳的資料結構
       */
      async queryByKeywords(keywords, additional = '') {
        const url = `${this.picture_api_url}?filter[of_keywords][0]=${keywords}`
        const additional_params = additional ? `&${additional}` : ''
        const response = await axios.get(`${url}${additional_params}`)
        return response.data
      },

      /**
       * 取得資料筆數
       * @param {string} param - API 查詢參數
       * @returns {Promise<Object>} API 回傳的資料結構
       */
      async getCount(param = '') {
        const url = `${this.picture_api_url}/count`
        const params = param ? `?${param}` : ''
        const response = await axios.get(`${url}${params}`)
        return response.data
      },

      /**
       * 透過編碼取得佛像
       * @param {string} code - 編碼
       * @param {string} additional - 額外的 API 查詢參數
       * @returns {Promise<Object>} API 回傳的資料結構
       */
      async getByCode(code, additional = '') {
        const url = `${this.picture_api_url}?filter[code]=${code}`
        const additional_params = additional ? `&${additional}` : ''
        const response = await axios.get(`${url}${additional_params}`)
      
        return response.data.data && response.data.data.length > 0
          ? { data: response.data.data[0] }
          : null
      },

      /**
       * 根據 ID 取得佛像
       * @param {string} id - ID
       * @param {string} additional - 額外的 API 查詢參數
       * @returns {Promise<Object>} API 回傳的資料結構
       */
      async getById(id, additional = '') {
        const url = `${this.picture_api_url}/${id}`
        const additional_params = additional ? `?${additional}` : ''
        const response = await axios.get(`${url}${additional_params}`)

        return response.data.data && Object.keys(response.data.data).length > 0
          ? response.data
          : null
      },

      /**
       * 取得可列印的電子檔案
       * @param {*} picture 
       * @param {*} default_value 
       * @returns 
       */
      async getPrintableEfile(picture, default_value = null) {
        const response = await axios.get(`${this.picture_api_url}/${picture.id}/printable-efile`)

        return response.data.data && Object.keys(response.data.data).length > 0
          ? response.data.data
          : default_value
      },

      /**
       * 取得可下載的電子檔案
       * @param {*} picture 
       * @param {*} default_value 
       * @returns 
       */
      async getDownloadableEfile(picture, default_value = null) {
        const response = await axios.get(`${this.picture_api_url}/${picture.id}/downloadable-efile`)

        return response.data.data && Object.keys(response.data.data).length > 0
          ? response.data.data
          : default_value
      },

      /**
       * 取得可預覽的電子檔案
       * @param {*} picture 
       * @param {*} default_value 
       * @returns 
       */
      async getPreviewableEfile(picture, default_value = null) {
        const response = await axios.get(`${this.picture_api_url}/${picture.id}/previewable-efile`)

        return response.data.data && Object.keys(response.data.data).length > 0
          ? response.data.data
          : default_value
      },
    }
  }
}
